/* eslint-disable no-param-reassign */

import commonApi from '@/apis/common';
const unescape = require('unescape');

export default {
    namespaced: true,
    state: () => ({
        isActive: false,
        noticeList: [],
    }),
    mutations: {
        init(state, payload) {
            state.noticeList = payload.noticeList.map(notice => ({...notice, "notice": unescape(notice.notice, "all")}));
            state.isActive = payload.noticeList.length > 0;
        },
    },
    actions: {
        async init({ commit }) {
            console.log('store::notice/init');
            const r = await commonApi.getNoticeList();
            commit('init', { noticeList: r, isActive: false });
        },
    },
    getters: {
        isActive: (state) => state.isActive,
        noticeList: (state) => state.noticeList,
    },
};
